import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './assets/styles.scss';
import { initializeAuthState } from './composables/useAuth';
import { setupChunkLoadErrorReload } from './utils/chunkReload';

initializeAuthState();
setupChunkLoadErrorReload();

const app = createApp(App);
app.use(router);
app.mount('#app');
